import React from 'react';
import { useDispatch } from 'react-redux';
import { Project } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  SectionProject,
  SectionPeriode,
} from './component/detail';

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const [data, setData] = React.useState();

  const $onLoad = async (id) => {
    const req = await Dispatch(Project.$show(id));

    if (req?.message === 'success') {
      setData(req?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="bg-white">
      <Page.Header title="Detil Project" />

      <Page.Navigation toolbar>
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Navigation>

      <Page.Body className="d-block px-3 py-4">
        <div className="row ">
          <div className="col-md-6">
            <SectionProject data={data} />
          </div>
          <div className="col-md-6">
            <SectionPeriode data={data} />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
